import type { EmployeeContactDetailsDto } from "@/generated/model/employeeContactDetailsDto";
import { useProfileSectionEditing } from "@/hooks/use-profile-section-form";
import { textOrNotRecorded } from "@/lib/people";

import { EditContactDetailsForm } from "../forms/EditContactDetailsForm";
import { ProfileSectionCard } from "../ProfileSectionCard";
import { ProfileSectionEditButton } from "../ProfileSectionEditButton";

interface ContactDetailsSectionProps {
  nurseryId: string;
  userId: string;
  contactDetails: EmployeeContactDetailsDto;
  canEdit: boolean;
}

export function ContactDetailsSection({
  nurseryId,
  userId,
  contactDetails,
  canEdit,
}: ContactDetailsSectionProps) {
  const { editing, editButtonRef, startEditing, stopEditing } =
    useProfileSectionEditing();

  return (
    <ProfileSectionCard
      title="Contact details"
      testId="profile-section-contact-details"
      action={
        canEdit &&
        !editing && (
          <ProfileSectionEditButton
            ref={editButtonRef}
            section="contact details"
            onClick={startEditing}
          />
        )
      }
      editForm={
        canEdit &&
        editing && (
          <EditContactDetailsForm
            nurseryId={nurseryId}
            userId={userId}
            contactDetails={contactDetails}
            onDone={stopEditing}
          />
        )
      }
      fields={[
        { label: "Mobile", value: textOrNotRecorded(contactDetails.mobile) },
        {
          label: "Secondary mobile",
          value: textOrNotRecorded(contactDetails.secondaryMobile),
        },
        {
          label: "Home phone",
          value: textOrNotRecorded(contactDetails.homePhone),
        },
        {
          label: "Personal email",
          value: textOrNotRecorded(contactDetails.personalEmail),
        },
        {
          label: "Work email",
          value: textOrNotRecorded(contactDetails.workEmail),
        },
      ]}
    />
  );
}
